import { render, staticRenderFns } from "./TimeSheetDetailsBody.vue?vue&type=template&id=04faef64&scoped=true&"
import script from "./TimeSheetDetailsBody.vue?vue&type=script&lang=js&"
export * from "./TimeSheetDetailsBody.vue?vue&type=script&lang=js&"
import style0 from "./TimeSheetDetailsBody.vue?vue&type=style&index=0&id=04faef64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04faef64",
  null
  
)

export default component.exports